angular.module('unica_room.room_controllers')

.controller('RoomCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	RoomCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getHotelList();

	$rootScope.roomData = {
		event_id: $stateParams.event_id
	};

	$scope.roomTypes = {};
	$scope.$on('hotel_list_loaded', function() {
		angular.forEach( $rootScope.hotelList, function(el) {
			$scope.roomTypes[ el.id ] = el.room_types;
		});
	});

	$scope.saveRoom = function() {
		$scope.showLoader();

		RoomCreateService
			.create( $rootScope.roomData )
			.then(function(data) {
				$scope.hideLoader();

				$scope.showSuccessMsg('Stanza aggiunta con successo!', '');

				$state.go('app.hospitality.room_list', { event_id: $stateParams.event_id });
			});

	};

});




